import React from "react";
import { createApi } from "../../../utils/createApi";
import { NavigateFunction } from "react-router-dom";
import { AxiosError, AxiosResponse } from "axios";
import { Dispatcher } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { universalAPIErrorHandler } from "../../../utils/universalAPIErrorHandler";
import { yyyymmddGenerator } from "../../Analytics/AnalyticsUtils/yyyymmddGenerator";

export const handleDownloadReport = (
  userFilters: any,
  setDownloadURL: Dispatcher<string>,
  setFetchingDownloadReport: Dispatcher<boolean>,
  navigate: NavigateFunction
) => {
  const retryFunction = () => {
    handleDownloadReport(
      userFilters,
      setDownloadURL,
      setFetchingDownloadReport,
      navigate
    );
  };

  const AxiosUI = createApi(``);

  if (userFilters?.parent_group) {
    setFetchingDownloadReport(true);
    const queryParams = new URLSearchParams({
      group: userFilters.parent_group,
    });

    if (userFilters.site) {
      queryParams.append("site", userFilters.site);
    }

    if (userFilters.start_date) {
      queryParams.append("start_date", yyyymmddGenerator(userFilters.start_date));
    }

    if (userFilters.end_date) {
      queryParams.append("end_date", yyyymmddGenerator(userFilters.end_date));
    }

    AxiosUI.get(`healthcheck_result/download/?${queryParams.toString()}`).then(
      (response: AxiosResponse) => {
        setDownloadURL(response.data.url);
        setFetchingDownloadReport(false);
      },
      (reason: AxiosError) => {
        setFetchingDownloadReport(false);
        universalAPIErrorHandler(reason, navigate, retryFunction, () => {});
      }
    );
  } else {
    setFetchingDownloadReport(false);
  }
};
